import type { FaireProductEntity } from "../../entity_types/product";

export const p_3re9rykrqj: FaireProductEntity = {
  token: "p_3re9rykrqj",
  type: "product",
  name: "Saltwater Jasmine– Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/e2454e795731a9d23e1c71de9dc1a695dbe5a4e1d078db760f59637eb8c0bc2c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/725157296a96323f864bfdaa56fbd30092be67f4b809e2ec4418aaccaf5291d7.jpeg",
    "https://cdn.faire.com/fastly/f0a70f503503abe7764e4fae6f098c85e604734ecc811a4bf8e737b78c254931.png",
    "https://cdn.faire.com/fastly/368f9b924a5a9fe2259fd47f85e803ec68de878541a5dd7f456454f38c14a4f5.png",
    "https://cdn.faire.com/fastly/4f7e0a70a11157e13a2f6bf9917a68873029d243f57c158108f75f6621ef5fc4.jpeg",
    "https://cdn.faire.com/fastly/4da90b05bfe8fcda02691060e933e67fd73537ba680a1212cb97710553f34794.jpeg",
  ],
  priceDollars: 5,
  description:
    '*NEW* Coastal mornings blanketed in a gentle marine layer, the warmth of the rising sun, wild white blossoms collecting dew. Ozonic, crisp, clean, with bergamot, muguet, sea moss, and sandalwood.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:49.909Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
